import ApplicationSetupRouter from './ApplicationSetupRouter'

export default ApplicationSetupRouter
